<template>
  <div class="kt-grid kt-grid--hor kt-grid--root">
    <RWHeaderMobile></RWHeaderMobile>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
    >
      <KTAside v-if="asideEnabled"></KTAside>
      <div
        class="
          kt-grid__item kt-grid__item--fluid
          kt-grid kt-grid--hor
          kt-wrapper
        "
        id="kt_wrapper"
      >
        <KTHeader></KTHeader>
        <div
          class="
            kt-content
            kt-grid__item kt-grid__item--fluid
            kt-grid kt-grid--hor
          "
          id="kt_content"
        >
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          ></KTSubheader>
          <div
            class="kt-container kt-grid__item kt-grid__item--fluid"
            v-bind:class="{ 'kt-container--fluid': contentFluid }"
          >
            <transition name="fade-in-up">
              <router-view></router-view>
            </transition>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>
    <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
    <!-- <KTQuickPanel></KTQuickPanel> -->
    <!--    <KTScrollTop></KTScrollTop>-->
    <widget-live-chat></widget-live-chat>
  </div>
</template>

<script>
import { LOGOUT } from "@/store/auth.module";
import { ApiURL } from "@/common/mixins/general.js";
import { mapGetters } from "vuex";
import { SET_PROFIL, GET_SUM_PRODUCT } from "@/store/rw/profile.module";

import widgetLiveChat from "@/views/partials/widgets/rw/widgetLiveChat";
import KTAside from "@/views/theme/aside/Aside.vue";
import KTHeader from "@/views/theme/header/Header.vue";
import RWHeaderMobile from "@/views/theme/header/HeaderMobile.vue";
import KTFooter from "@/views/theme/footer/Footer.vue";
import HtmlClass from "@/common/htmlclass.service";
import KTSubheader from "@/views/theme/subheader/Subheader.vue";
import KTStickyToolbar from "@/views/partials/layout/StickyToolbar.vue";
// import KTScrollTop from "@/views/partials/layout/ScrollTop";
import Loader from "@/views/partials/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
  name: "Base",
  mixins: [ApiURL],
  components: {
    KTAside,
    KTHeader,
    RWHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    // KTScrollTop,
    Loader,
    widgetLiveChat
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "kt-page--loading");

    // initialize html element classes
    HtmlClass.init();
  },
  mounted() {
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    /**
     * --------------------------------------------------
     * get profile every mounted
     * karna ketika save di state akan hilang when reload
     * --------------------------------------------------
     */
    this.$store
      .dispatch(SET_PROFIL, { url: this.api.user.profile })
      .catch(() => {
        this.$store
          .dispatch(LOGOUT)
          .then(() => this.$router.push({ name: "login" }));
        console.log("can't get profil : logout n redirect login");
      })
      .finally(() =>
        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "kt-page--loading")
      );

    /**
     * --------------------------------------------------
     * request sumProduct sidebar
     * --------------------------------------------------
     */
    this.$store
      .dispatch(GET_SUM_PRODUCT, { url: this.api.product.general.sum })
      .catch(() => {
        this.$store
          .dispatch(LOGOUT)
          .then(() => this.$router.push({ name: "login" }));
        console.log("can't get sum product : logout n redirect login");
      });
  },
  methods: {},
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),

    /**
     * Check if the page laoder is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !!this.layoutConfig("loader.enabled");
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      return !!this.layoutConfig("toolbar.display");
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    }
  }
};
</script>
